export default function GuestSpeaker() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-yellow-500 text-black px-6 py-2 rounded-full font-bold mb-6">
            <i className="ri-star-fill mr-2"></i>
            Der Höhepunkt der Masterclass
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
            Gastredner mit <span className="text-yellow-500">25 Jahren Dubai-Erfahrung</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Ein deutscher Steuerberater, der seit über 25 Jahren in Dubai lebt, gibt Einblicke aus erster Hand
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/abe6baadcf849fd55c82fd5214fe01c8.jpg"
              alt="Gastredner - Dubai Experte seit 25 Jahren"
              className="w-full h-[500px] object-cover object-top rounded-2xl shadow-2xl"
            />
            <div className="absolute bottom-6 left-6 right-6 bg-black/80 backdrop-blur-sm rounded-xl p-6">
              <div className="flex items-center mb-2">
                <i className="ri-user-star-fill text-yellow-500 text-2xl mr-3"></i>
                <span className="text-white font-bold text-xl">Deutscher Steuerberater</span>
              </div>
              <p className="text-gray-300">Seit über 25 Jahren in Dubai ansässig</p>
            </div>
          </div>

          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Authentisch. Glaubwürdig. <span className="text-yellow-500">Dubai erlebt statt nur gelesen.</span>
            </h3>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Dieser Gastredner ist der <strong>rote Faden des Seminars</strong> – mit 2½ Jahrzehnten Erfahrung vor Ort bietet er Insiderwissen, das man sonst nirgends bekommt.
            </p>

            <div className="space-y-6">
              <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl p-6 border-l-4 border-blue-500">
                <div className="flex items-start">
                  <i className="ri-time-line text-blue-500 text-2xl mr-4 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">Dubai „damals" mit Sandstraßen</h4>
                    <p className="text-gray-700">Persönliche Erlebnisse aus der Anfangszeit der Transformation</p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-yellow-50 to-yellow-100 rounded-xl p-6 border-l-4 border-yellow-500">
                <div className="flex items-start">
                  <i className="ri-building-line text-yellow-500 text-2xl mr-4 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">Aufbau des Finanz- und Firmenstandorts</h4>
                    <p className="text-gray-700">Wie sich Dubai zum globalen Business-Hub entwickelt hat</p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-green-50 to-green-100 rounded-xl p-6 border-l-4 border-green-500">
                <div className="flex items-start">
                  <i className="ri-exchange-line text-green-500 text-2xl mr-4 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">Wie sich Regeln, Steuern und Strukturen verändert haben</h4>
                    <p className="text-gray-700">Evolution der rechtlichen und steuerlichen Rahmenbedingungen</p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-purple-50 to-purple-100 rounded-xl p-6 border-l-4 border-purple-500">
                <div className="flex items-start">
                  <i className="ri-lightbulb-line text-purple-500 text-2xl mr-4 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">Persönliche Fehler &amp; Erfolgsstories</h4>
                    <p className="text-gray-700">Lernen Sie aus echten Erfahrungen – was funktioniert und was nicht</p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-red-50 to-red-100 rounded-xl p-6 border-l-4 border-red-500">
                <div className="flex items-start">
                  <i className="ri-key-line text-red-500 text-2xl mr-4 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">Insiderwissen, das man sonst nirgends bekommt</h4>
                    <p className="text-gray-700">Echtes Wissen aus 2½ Jahrzehnten vor Ort</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-gray-900 via-gray-800 to-black rounded-3xl p-12 text-center text-white">
          <i className="ri-double-quotes-l text-yellow-500 text-5xl mb-6 inline-block"></i>
          <blockquote className="text-2xl md:text-3xl font-medium italic mb-6 leading-relaxed">
            „Ich habe Dubai von der Sandwüste zur Weltmetropole wachsen sehen. Dieses Wissen und diese Erfahrungen möchte ich mit Ihnen teilen – damit Sie die richtigen Entscheidungen treffen."
          </blockquote>
          <cite className="text-lg text-gray-300 font-medium">
            – Gastredner der Dubai Masterclass
          </cite>
        </div>

        <div className="mt-16 text-center">
          <a 
            href="/seminar#buchung"
            className="inline-block bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-white px-12 py-5 rounded-full font-bold text-xl transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line mr-3"></i>
            Jetzt zur Masterclass anmelden
          </a>
          <p className="text-gray-600 mt-6 text-lg">
            Die Masterclass findet am Tag 2 im Burj Al Arab statt
          </p>
        </div>
      </div>
    </section>
  );
}
